import { ExtendedPermission, Maybe, PermissionLevel } from "fond/types";
import { allowEditPermissionLevel } from "fond/utils/permissions";

export const labels: Record<PermissionLevel, string> = {
  manage: "Manager",
  write: "Contributor",
  read: "Collaborator",
  view: "Viewer",
  deny: "Denied",
};

type Option = {
  value: string;
  displayValue: string;
  inheritValue?: PermissionLevel;
  disabled: boolean;
};

/**
 * Determines the Select options to render & which are disabled based on permissions
 */
export const getOptions = (permission: Maybe<string | ExtendedPermission>, currentPermission: PermissionLevel, isExternal = false): Option[] => {
  const labelKeys = Object.keys(labels);
  const enabledOptions = isExternal ? labelKeys.filter((key) => key !== "manage" && key !== "write") : labelKeys;
  const options: Option[] = enabledOptions.map((key: string) => ({
    value: key,
    displayValue: labels[key as PermissionLevel],
    disabled: !allowEditPermissionLevel(currentPermission, key as PermissionLevel),
  }));

  if (permission && typeof permission !== "string" && permission.Inherited) {
    options.unshift({
      value: "inherited",
      displayValue: `${labels[permission.Inherited]} (Inherited)`,
      inheritValue: permission.Inherited,
      disabled: !allowEditPermissionLevel(currentPermission, permission.Inherited, true),
    });
  }
  return options;
};

/**
 * Since we use a different Label field for users vs accounts, we need a helper to get the correct property name.
 * FIXME: Standardize on using a single property for both user and account display names (e.g. DisplayName).
 */
export const getUsernameLabel = (permission: Maybe<ExtendedPermission>): string => {
  if (permission?.IdentityType === "user" && permission.Identity.Email) {
    return permission.Identity.Email;
  } else if (permission?.IdentityType === "account") {
    return permission.Identity.Name;
  }

  return "";
};
